import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";

import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import CandidateInformation from "./candidateInformation";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SearchWithFilter from "./search";
import { getAllApplied } from "./jobsApi";
import AppliedCandidateModal from "./AppliedModal";

const AppliedCandidate = ({ appliedCandidate, backPost }) => {
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();

  const [Applied, setApplied] = useState();



 
  const navigate = useNavigate();

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );



  const getAllApplieded = async (param) => {
    const payload = {
      jobId: appliedCandidate.id,
    };


    getAllApplied(payload, (data) => {
      console.log("Job applied ", data.data.data.list);
      setApplied(data.data.data.list);
    });
  };

  useEffect(() => {
    getAllApplieded();
  }, []);

  const tableGrid = {
    display: "grid",
    gridTemplateColumns: "200px 200px 180px 200px 200px",
    alignItems: "center",
  };

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container px={2} spacing={{ xs: 1, sm: 2 }}>
          <IconButton
            onClick={() => backPost()}
            sx={{
              "&:hover": {
                backgroundColor: "transparent", // removes hover background
              },
            }}
          >
            <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
          </IconButton>
          <Grid
            item
            xs={12}
            sm={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "16px",
              }}
              fontWeight="400"
            >
              Applied Candidates
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={{ sm: 1, md: 2, xs: 1 }} sx={{}}>
          <Grid
            item
            xs={12}
            //   sm={5}
            sx={{
              fontWeight: "bold",
              mt: { xs: "10px", sm: "0px" },
            }}
          >
            {/* <TextField
              fullWidth
              id="Value"
              label="Search..."
              size="small"
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                border: "none",
                "& fieldset": { border: "none" },
              }}
              // value={employeeDetail?.name}
              onChange={(e) => {}}
              InputProps={{
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
                endAdornment: (
                  <SearchIcon
                    //   onClick={() => {
                    //     setOpenT(true);
                    //   }}
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                      cursor: "pointer",
                    }}
                  />
                ),
              }}
              InputLabelProps={{
                sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } }, // ✅ input value font size
                // shrink: !!employeeDetail?.name,
              }}
            /> */}

            <SearchWithFilter />
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            px: 2,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box sx={{ minWidth: "1100px" }}>
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
                px: 10,
              }}
            >
              <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                Candidate Name
              </Box>

              <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                Mobile Number
              </Box>

              {/* <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                Gender
              </Box> */}

              <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                Skills
              </Box>
              {/* <Box
                sx={{ textAlign: "center", color: "#01008B", fontWeight: 500 }}
              >
                Specialization
              </Box> */}
              <Box />
            </Box>

            {/* DATA ROW */}
            {Applied?.map((appli, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1,
                    px: 10,

                    // width: "fit-content",
                  }}
                  onClick={() => {
                    setModalData(appli);
                    setOpen(true);
                  }}
                >
                  <Box sx={{ px: 2, fontWeight: "medium" }}>
                    {appli.candidateName}
                  </Box>

                  <Box sx={{ textAlign: "center", fontWeight: "medium" }}>
                    {appli.candidateMobile}
                  </Box>

                  {/* <Box sx={{ textAlign: "center" }}>Male</Box> */}

                  <Box sx={{ fontWeight: "medium" }}>{appli.skills}</Box>

                  {/* <Box sx={{ textAlign: "center", fontWeight: "medium" }}>
                   Hair cut specialist
                 </Box> */}
                </Box>
              );
            })}
          </Box>
        </Box>

        <AppliedCandidateModal
          modalData={modalData}
          open={open}
          setOpen={setOpen}
          getRecept={() => {
            // getPaymentRec({ ...getPaymentObj });
          }}
        />
      </Box>
    </>
  );
};

export default AppliedCandidate;
